var wrapperElements = ['html', 'body', '#wrap']
var emptyPoints = 0

function getSelector(element) {
  if (element.id) {
    return '#' + element.id
  } else if (element.className) {// a b c => .a.b.c
    return '.' + element?.className?.split(' ')?.filter(item => !!item)?.join('.')
  } else {
    return element.nodeName.toLowerCase()
  }
}

function isWrapper(element) {
  try {
    var selector = getSelector(element)
    if (selector && wrapperElements.includes(selector)) {
      emptyPoints++
    }
  } catch (e) {

  }

}

function CheckWhiteScreen() {
  const check = () => {
    for (var i = 1; i <= 9; i++) {
      var xElements = document.elementsFromPoint(
        window.innerWidth * i / 10, window.innerHeight / 2)
      var yElements = document.elementsFromPoint(
        window.innerWidth / 2, window.innerHeight * i / 10)
      isWrapper(xElements[0])
      isWrapper(yElements[0])
    }
  }

  var id = ''
  var count = 1

  var maxCount = ['msem'].some((item) => window.location.pathname.includes(item)) ? 5 : 3

  function p() {
    window.clearTimeout(id)
    id = setTimeout(() => {
      console.log(count + ' times')
      check()
      if (count === maxCount) {
        var centerElements = document.elementsFromPoint(
          window.innerWidth / 2, window.innerHeight / 2
        )
        window.clearTimeout(id)
        // 绝对的白屏6s，当然有可能是网络问题，渲染的慢，但是没捕获到错误
        if (getSelector(centerElements[0]) === 'html') {
          if (window.params.message) {
            sendError({
              level: 'error',
              message: '【 PC 】  error：' + maxCount + 's内没渲染出来+ ' + ' 报错：' + params.message,
              stack: getSelector(centerElements[0]),
              error: '【 PC 】  error：' + maxCount + 's内没渲染出来+ ' + '报错：' + params.message
            })
          } else {
            // 暂时不上报
            // sendError({
            //     level: 'error',
            //     message: 'warn: ' + maxCount + 's内没渲染出来 ',
            //     stack: getSelector(centerElements[0]),
            //     error: 'warn: ' + maxCount + 's内没渲染出来 '
            // })
          }

        }
        return
      }

      if (emptyPoints >= 18) {
        count = count + 1
        p()
      } else {
        window.clearTimeout(id)
      }
    }, 1000)
  }

  p()

}


// ChunkLoadFailed错误强制刷新一次
function forceRefresh() {
  if(location.href.indexOf('#reloaded')===-1){
    location.href = location.href + '#reloaded';
    window.location.reload(true);
  }
}

function checkChunkLoadFailed(message) {
  var reg = /Loading([\s\S])*chunk (\d)+ failed/g
  var isChunkLoadFailed = message.match(reg);
  if (isChunkLoadFailed) return forceRefresh()
}

function sendError(params) {
  // checkChunkLoadFailed(params.message)

  var isLoadFailed = params.message.match(/Loading\s+(?:CSS\s+chunk|chunk)\s+\d+\s+failed/g);
  if(isLoadFailed) return

  // 忽略报警 msem 的报警
  if (['2023-annual-report'].some((item) => window.location.pathname.includes(item))) {
    return
  }
  // 忽略报警
  if (['Googlebot','search/spider.html','spider'].some((item) => navigator.userAgent.includes(item))) {
    return
  }
  //  忽略的错误
  if (['checkReadability','removeChild','scroll'].some((item) => params.message.includes(item))) {
    return
  }
  // note:暂时去掉。上线恢复
  try {
    if (!['www.zhumavip.com', 'www.zhongheschool.com'].includes(window.location.hostname)) {
      return
    }
  } catch (e) {

  }

  try {
    var data = {
      project_slug: 'zhongheschool-wap',
      projectName: 'zhongheschool-wap',
      project_name: 'zhongheschool-wap',
      level: params.level,
      culprit: params.stack,// 起因
      message: "centaur-pc"+  params.message + ' \n navigator.userAgent：' + navigator.userAgent + ' \n url：' + window.location.href,
      url: window.location.href,
      error: params.error || params.event,
      event: {
        environment: 'prod',
        timestamp: Date.now() / 1000,
        version: '【 PC 】1.0.2'
      },
      userAgent: navigator.userAgent
    }

    var xhr = new XMLHttpRequest()
    var url = 'https://online-api.zhongheschool.com/api/sentry/monitor'
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    // 钉钉机器人需要的JSON数据
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        console.log(xhr.responseText) // 如果一切正常，这里会打印钉钉服务器返回的信息
      } else if (xhr.status !== 200) {
        console.error('Error: ' + xhr.status)
      }
    }
    xhr.send(JSON.stringify(data))
  } catch (e) {
    console.log(e)
  }

}


function TopSendError(response) {
  try {
    const userInfo = JSON.parse(localStorage.getItem('react_user_info'))
    console.warn(`url: ${response.config.baseURL}${response.config.url}
             userId:${userInfo?.userId || '无'}
             mobile：${userInfo?.mobile || '无'}
            token：${userInfo?.token || '无'}
             params:${JSON.stringify(response.config.data) || JSON.stringify(response.config?.params) || ''}
             返回数据：${JSON.stringify(response?.data)}`)
    const msg = `url: ${response.config.baseURL}${response.config.url}
             userId:${userInfo?.userId || '无'}
             mobile：${userInfo?.mobile || '无'}
            token：${userInfo?.token || '无'}
             params:${JSON.stringify(response.config.data) || JSON.stringify(response.config?.params) || ''}
             返回数据：${JSON.stringify(response?.data)}`

    sendError({
      level: 'error',
      message: msg,
      stack: 1000 || '',
      error: msg
    })

  } catch (e) {
    debugger
  }
}

export { CheckWhiteScreen, sendError,TopSendError }
